export function Check({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M9.55 17.725q-.225 0-.425-.075-.2-.075-.375-.25l-4.3-4.3q-.325-.325-.312-.813.012-.487.337-.812.325-.325.813-.325.487 0 .787.325L9.55 14.95l8.375-8.375q.3-.325.8-.325t.825.325q.3.325.3.812 0 .488-.3.813l-9.2 9.2q-.175.175-.375.25-.2.075-.425.075Z" />
    </svg>
  );
}
